import UserSmallHeader from 'components/Headers/UserSmallHeader';
import FloatingButton from 'components/FloatingButton';
import { FaPrint } from 'react-icons/fa';
import ResultadoIrrigacao from '../ResultadoIrrigacao';
import './style.css';

interface Props {
  orcamentoVersaoId: number;
  tipoProduto: string;
  isPrevia: boolean | false;
}

export default function Impressao(props: Props): JSX.Element {
  const { orcamentoVersaoId, tipoProduto, isPrevia } = props;

  return (
    <>
      <div className="hide-on-print">
        <UserSmallHeader />
      </div>
      <div
        className={`content-to-print body-print print-fv ${
          isPrevia ? 'watermark-container' : ''
        }`}
        style={{ width: '100%', padding: '5px', height: '100%' }}
      >
        {tipoProduto === 'Irrigacao' && (
          <ResultadoIrrigacao
            configuracaoId={orcamentoVersaoId}
            isPrevia={isPrevia}
          />
        )}
        {tipoProduto === 'Fotovoltaica' && (
          <div>Modelo para impressão não configurada para este produto</div>
        )}
      </div>
      <FloatingButton
        hidden={isPrevia}
        className="hide-on-print"
        onClick={() => window.print()}
      >
        <FaPrint />
      </FloatingButton>
    </>
  );
}
